import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-douyin",
  "use": "icon-douyin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-douyin\"><path d=\"M21.15 10.106a9.08 9.08 0 01-5.266-1.673v7.57A7 7 0 018.88 23a7 7 0 01-7.004-6.996 7 7 0 018.132-6.905v4.01a3.124 3.124 0 00-4.225 2.923c0 1.725 1.4 3.123 3.125 3.123a3.124 3.124 0 003.126-3.122l-.001-.03V1h3.908a5.235 5.235 0 005.237 5.233v3.873h-.029\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol